import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Globals } from './globals';
import { HttpClient } from '@angular/common/http';
import { Dashboard } from 'app/models/dashboard';
import { of, BehaviorSubject } from 'rxjs';
import { UserService } from './user.service';
import { tap, finalize } from 'rxjs/operators';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class DashboardService {

    constructor(private http: HttpClient, private globals: Globals, private userService: UserService, 
                private formBuilder: FormBuilder) {
        this.userService.currentUser.subscribe(user => {
            if (user && this.globals.api_base_url) {
                this.getAll().subscribe();
            }
        });
    }

    formGroup(dashboard: Dashboard = null){
        let frmGrp: FormGroup = this.formBuilder.group({
            id: [(dashboard)? dashboard.id: null],
            name: [(dashboard)? dashboard.name: '', [Validators.required, Validators.maxLength(255)]],
            url: [(dashboard)? dashboard.url: '', [Validators.required]],
            tags: [(dashboard)? dashboard.tags: []]
        });

        frmGrp.get('url').valueChanges.subscribe((newValue) => {
            const regexRes: RegExpExecArray = /^.*\"(http[^\"]*)\".*$/.exec(newValue);

            if (regexRes && regexRes[1] != newValue) {
                frmGrp.get('url').setValue(regexRes[1]);
            }
        });

        return frmGrp;
    }

    currentDashboardsSubject: BehaviorSubject<Dashboard[]> = new BehaviorSubject<Dashboard[]>([]);

    // Use subscription on currentDashboardsSubject instead
    private getAll() {
        return this.http.get<Dashboard[]>(`${this.globals.api_base_url}/dashboards`, {}).pipe(tap((d) => {
            this.currentDashboardsSubject.next(d);
        }));
    }

    public getById(dashboardId: number) {
        return this.http.get<Dashboard>(`${this.globals.api_base_url}/dashboard/${dashboardId}`, {});
    }

    public delete(dashboardId: number) {
        return this.http.delete(`${this.globals.api_base_url}/dashboard/${dashboardId}`, {}).pipe(finalize(() => {
            this.getAll().subscribe();
        }));
    }

    public put(dashboard: Dashboard) {
        return this.http.put(`${this.globals.api_base_url}/dashboard`, dashboard).pipe(finalize(() => {
            this.getAll().subscribe();
        }));
    }
}